import React, { useState, useEffect } from "react";
import "./Navbar.css";
import { Link } from "react-router-dom";
import {
  FaUser,
  FaImages,
  FaFeatherAlt,
  FaCalendarCheck,
  FaSignInAlt,
} from "react-icons/fa";

function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      // Set scrolled state to true if user has scrolled more than 10px
      setIsScrolled(window.scrollY > 10);
    };

    // Add event listener when the component mounts
    window.addEventListener("scroll", handleScroll);

    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []); // Empty dependency array means this effect runs only once on mount

  const navLinks = [
    { to: "/about", text: "About", Icon: FaUser },
    { to: "/portfolio", text: "Portfolio", Icon: FaImages },
    { to: "/blog", text: "Blog", Icon: FaFeatherAlt },
    { to: "/booking", text: "Booking", Icon: FaCalendarCheck },
    { to: "/client", text: "Login", Icon: FaSignInAlt },
  ];

  return (
    <nav className={`navbar ${isScrolled ? "scrolled" : ""}`}>
      <div className="navbar-container">
        <Link to="/">
          <img src="/logo.png" alt="TjWit Media Logo" className="navbar-logo" />
        </Link>
        <div className="nav-links">
          {navLinks.map((link) => (
            <Link to={link.to} key={link.to} className="nav-link">
              <span className="nav-text">{link.text}</span>
              <link.Icon className="nav-icon" />
            </Link>
          ))}
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
